import { FC, ReactNode } from 'react';

import { LayoutBlock } from '../LayoutBlock';
import { VerticalSlider } from '../VerticalSlider';

import styles from './SliderBlock.css';

type TSliderBlockProps = {
  children: ReactNode[];
  title: string;
  sourceLabel: string;
  sourceTooltip: ReactNode;
  id: string;
  onShow: () => void;
};

export const SliderBlock: FC<TSliderBlockProps> = ({ id, children, title, sourceLabel, sourceTooltip, onShow }) => {
  return (
    <LayoutBlock
      contentOffset={24}
      id={id}
      title={title}
      semiTitle={{ title: sourceLabel, hint: sourceTooltip }}
      onView={onShow}
    >
      <div className={styles['slider']}>
        <VerticalSlider arrow={() => null} containerClass={styles['slider-list']}>
          {children}
        </VerticalSlider>
      </div>
    </LayoutBlock>
  );
};
